import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintManager_ds_reason_codes_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { fullTextSearch?: string, parentEntity?: string, parentId?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, EnumName?: string, Label?: string, LookupCode?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Name?: string, NumberOfMinutesBeforeExpiration?: number, ParentEntity?: string, ParentId?: number, SystemDefined?: boolean }[] }> 
  {
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_reason_codes_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { fullTextSearch?: string, parentEntity?: string, parentId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, EnumName?: string, Label?: string, LookupCode?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Name?: string, NumberOfMinutesBeforeExpiration?: number, ParentEntity?: string, ParentId?: number, SystemDefined?: boolean }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_reason_codes_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { fullTextSearch?: string, parentEntity?: string, parentId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, EnumName?: string, Label?: string, LookupCode?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Name?: string, NumberOfMinutesBeforeExpiration?: number, ParentEntity?: string, ParentId?: number, SystemDefined?: boolean }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_reason_codes_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      fullTextSearch?: string, parentEntity?: string, parentId?: number    }) {
      return false;
    }
}
